import * as Sentry from "@sentry/react";

/**
 * Initializes Sentry error monitoring, performance tracing and session
 * replay. No-ops if REACT_APP_SENTRY_DSN isn't set, so it's safe to call
 * unconditionally at app startup.
 */
export function initSentry() {
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.NODE_ENV,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      // Performance tracing
      tracesSampleRate: 1.0,
      tracePropagationTargets: ["localhost", process.env.REACT_APP_API_URL],
      // Session replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      enableLogs: true,
    });
    console.log("Sentry error monitoring enabled");
  } else {
    console.log("Sentry disabled (no REACT_APP_SENTRY_DSN set)");
  }
}

export { Sentry };
